var map = {
	"./0caca.png": 226,
	"./1caca.png": 227,
	"./2caca.png": 228,
	"./3caca.png": 229,
	"./asistio.png": 230,
	"./ausencia.png": 231,
	"./ausente.png": 232,
	"./despierto.png": 233,
	"./dormido.png": 234,
	"./edit.png": 235,
	"./fruta.png": 236,
	"./malcaca.png": 237,
	"./mitad.png": 238,
	"./nada.png": 239,
	"./no-caca.png": 240,
	"./nocome.png": 241,
	"./parcial.png": 242,
	"./pure-huevo.png": 243,
	"./pure-pavo.png": 244,
	"./pure-pescado.png": 245,
	"./pure-pollo.png": 246,
	"./pure-ternera.png": 247,
	"./pure.png": 248,
	"./todo.png": 249,
	"./xcaca.png": 250,
	"./yogur.png": 251
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons nonrecursive ^\.\/.*$
// module id = 225
// module chunks = 1